export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_08.546b98a5.jpg";